import React from 'react';
import BlogManagement from '../components/BlogManagement';

const BlogManagementPage: React.FC = () => <BlogManagement />;

export default BlogManagementPage;
